export class ListActionApprovalRulesRequestFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operation",
            "baseName": "operation",
            "type": "ActionApprovalOperationType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListActionApprovalRulesRequestFilters.attributeTypeMap;
    }
    constructor() {
    }
}
